// src/components/About.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import './About.css';

const About = ({ t, language }) => {
  const contactLinks = [
    {
      icon: <FaGithub />,
      label: 'GitHub',
      url: 'https://github.com/Bat0oo',
      color: 'blue'
    },
    {
      icon: <FaLinkedin />,
      label: 'LinkedIn',
      url: 'https://www.linkedin.com/in/miloradmaksic01/',
      color: 'blue'
    },/*
    {
      icon: <FaInstagram />,
      label: 'Instagram',
      url: 'https://www.instagram.com/bat0oo/',
      color: 'pink'
    }, */
    {
      icon: <FaEnvelope />,
      label: 'Email',
      url: 'mailto:miloradmaksic01@gmail.com',
      color: 'green'
    }
  ];

  return (
    <section className="about" id="about">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title neon-text">{t.about.title}</h2>
          
          <div className="about-content">
            {/* Photo and Quick Info */}
            <motion.div 
              className="about-left"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              {/* PHOTO PLACEHOLDER - Add your photo here */}
              <div className="about-photo-container">
                <div className="about-photo-placeholder neon-border">
                  <div className="photo-icon">
                    <FaMapMarkerAlt />
                  </div>
                  <p className="photo-instruction">
                    {/* INSTRUCTIONS: Replace this div with an img tag
                        <img src="/path/to/your-photo.jpg" alt="Milorad Maksić" />
                        Recommended size: 400x400px or larger (square)
                        Supported formats: .jpg, .png, .webp
                        Place your photo in the /public folder
                    */}
                    Photo placeholder
                  </p>
                </div>
              </div>
              
              {/* Quick Info Cards */}
              <div className="about-quick-info">
                <motion.div 
                  className="info-card neon-border-green"
                  whileHover={{ scale: 1.05, boxShadow: 'var(--glow-green)' }}
                >
                  <FaMapMarkerAlt className="info-icon" />
                  <span>{t.about.location}</span>
                </motion.div>
                
                <motion.div 
                  className="info-card neon-border"
                  whileHover={{ scale: 1.05, boxShadow: 'var(--glow-blue)' }}
                >
                  <span className="status-dot"></span>
                  <span>{t.about.status}</span>
                </motion.div>
              </div>

              {/* Contact Links */}
              <div className="about-social">
                {contactLinks.map((link, index) => (
                  <motion.a
                    key={index}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`social-icon social-icon-${link.color}`}
                    whileHover={{ scale: 1.2, rotate: 5 }}
                    whileTap={{ scale: 0.9 }}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3 + index * 0.1 }}
                    viewport={{ once: true }}
                  >
                    {link.icon}
                    <span className="social-label">{link.label}</span>
                  </motion.a>
                ))}
              </div>
            </motion.div>

            {/* Bio and Info */}
            <motion.div 
              className="about-right"
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              {/* Bio Text */}
              <div className="about-bio">
                {/* INSTRUCTIONS FOR EDITING BIO:
                    1. Open src/translations.js
                    2. Find the 'about.bio' section
                    3. Edit the text for both 'en' and 'sr'
                    4. Keep the formatting (paragraph breaks work with \n\n)
                */}
                {t.about.bio.split('\n\n').map((paragraph, index) => (
                  <p key={index} className="bio-paragraph">
                    {paragraph}
                  </p>
                ))}
              </div>

              {/* Education Highlight */}
              <motion.div 
                className="about-education-highlight neon-border"
                whileHover={{ scale: 1.02 }}
              >
                <div className="edu-icon">🎓</div>
                <div className="edu-content">
                  <h4>{t.about.education}</h4>
                  <p>{t.education.institution}</p>
                </div>
              </motion.div>

              {/* Interests */}
              <div className="about-interests">
                <h3 className="interests-title neon-text-green">
                  {t.about.interests}
                </h3>
                <div className="interests-grid">
                  {t.about.interestsList.map((interest, index) => (
                    <motion.div
                      key={index}
                      className="interest-tag"
                      initial={{ opacity: 0, scale: 0.8 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      transition={{ delay: 0.4 + index * 0.1 }}
                      whileHover={{ 
                        scale: 1.1,
                        boxShadow: 'var(--glow-green)'
                      }}
                      viewport={{ once: true }}
                    >
                      {interest}
                    </motion.div>
                  ))}
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
